import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../actions";
import { useLocation } from "react-router-dom";
import * as Template from "../../templates";
 
export default () => {

  const moduleName = "vouchers";
  const location = useLocation()
  const appReducer = useSelector((state) => state.appReducer);
  const dispatch = useDispatch();
  const [rows, setRows] = useState([])
  const [totalPages, setTotalPages] = useState(0)

  const handleDelete = id => dispatch(actions.destroy(id, moduleName))

  useEffect(() => {
    dispatch(actions.list(moduleName, location.search));
  }, [appReducer.vouchers_destroy, location.search]);

  useEffect(() => {
    if (appReducer.vouchers_list != undefined) {
      setRows(appReducer.vouchers_list.data)
      setTotalPages(appReducer.vouchers_list.count)
    }
  }, [appReducer])


  const columns = [
    {
      name: 'نام',
      selector: row => row.name ?? "-",
    },
    {
      name: 'کد تخفیف',
      selector: row => row.hash
    },
    {
      name: 'مقدار تخفیف',
      selector: row => row.amount
    },
    {
      name: 'تعداد',
      selector: row => row.counts
    },
    {
      name: 'تاریخ انقضا',
      selector: row => row.expire_at_fa
    },
    {
      name: 'تعداد استفاده',
      selector: row => row.used
    },
    {
      name: 'هزینه حمل رایگان',
      selector: row => <Template.State variant={row.free_shipping} />
    },
    {
      name: 'وضعیت',
      selector: row => <Template.State variant={row.state} />,
    },
    {
      name: 'عملیات',
      selector: row => <Template.TableButton handleDelete={() => handleDelete(row.id)} row={row} location={location} />,
    },
  ];

  return <Template.Table count={totalPages}  columns={columns} data={rows} />;

};
